let isScrollDisabled = false;
function disableScroll() {
    if (isScrollDisabled) return;
    isScrollDisabled = true;
    const scrollY = window.scrollY;
    document.body.style.position = "fixed";
    document.body.style.top = `-${scrollY}px`;
    document.body.style.width = "100%";
}

function enableScroll() {
    if (!isScrollDisabled) return;
    isScrollDisabled = false;
   const scrollY = Math.abs(parseInt(document.body.style.top || "0", 10));
    document.body.style.position = "";
    document.body.style.top = "";
    window.scrollTo(0, scrollY);
}

let thumbSwiper = null;
let mainSwiper = null;
function destroyQuickViewSwipers() {
  if (thumbSwiper) {
    thumbSwiper.destroy(true, true);
    thumbSwiper = null;
  }
  if (mainSwiper) {
    mainSwiper.destroy(true, true);
    mainSwiper = null;
  }
}
function initQuickViewSwipers(modal) {
const submitButtons = document.querySelectorAll(
  ".product-form__buttons .product-form__submit"
);

submitButtons.forEach(btn => {
  if (btn.classList.contains("block_sold-out-products")) return;
  btn.classList.remove("disabled");
  btn.removeAttribute("disabled");
});
  // destroyQuickViewSwipers();
  // const thumbSliderEl = modal.querySelector('.thumb-slider');
  // const mainSliderEl = modal.querySelector('.main-slider');
  // if (!thumbSliderEl || !mainSliderEl) return;
  // thumbSwiper = new Swiper(thumbSliderEl, {
  //   spaceBetween: 6,
  //   slidesPerView: 5.8,
  //   watchSlidesProgress: true,
  //   slideToClickedSlide: true,
  //    loop: false,
  //   navigation: {
  //     nextEl: modal.querySelector('.swiper-button-next'),
  //     prevEl: modal.querySelector('.swiper-button-prev'),
  //   },
  //   direction: 'vertical',
  //   breakpoints: {
  //     768: {
  //       direction: 'vertical',
  //     },
  //     0: {
  //       direction: 'vertical',
  //     }
  //   }
  // });
  // mainSwiper = new Swiper(mainSliderEl, {
  //   spaceBetween: 6,
  //   direction: "horizontal",
  //   thumbs: {
  //     swiper: thumbSwiper,
  //   },
  //   pagination: {
  //     el: modal.querySelector('.swiper-pagination'),
  //     clickable: true,
  //   },
  // });



      if(document.querySelectorAll(".content_heading").length > 0){
 
      let wrappers = document.querySelectorAll(".content_heading");
      wrappers.forEach(function(wrapper) {
        var price = wrapper.getAttribute("data-price");
        if (price) {
          wrapper.querySelector("span").textContent = Shopify.formatMoney(price);
        }
      });
     }

  const mainSliderEl = modal.querySelector('.main-slider');
  if (!mainSliderEl) return;

  let swiperinfo = new Swiper(mainSliderEl, {
    direction: "vertical",
    slidesPerView: 2.6,
    spaceBetween: 0,
    mousewheel: true, // enable mouse scroll
    navigation: {
      nextEl: modal.querySelector('.swiper-button-next'),
      prevEl: modal.querySelector('.swiper-button-prev'),
    },
  });
 
}


if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
          setTimeout(() => {

          initQuickViewSwipers(this); 
        }, 100);
        });
      }


      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer') ;
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }
      
      show(opener) {
        document.body.classList.add('drawer-open');
        disableScroll();
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

      


        
        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');
            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();
            
             document.querySelectorAll("quick-add-modal").forEach(function(modal) {
                modal.removeAttribute("open");
             });
          
            super.show(opener);

           initQuantityBreaks();

          function swymCallbackFn(swat) {
          function swymAttachEvents() {
            swat.initializeActionButtons("body");
          }
          document.addEventListener('quick-add-modal:loaded', function(e) {
            setTimeout(() => {
              swymAttachEvents();   
            }, 300);
          });
          swymAttachEvents();
        }
        window.SwymCallbacks = window.SwymCallbacks || [];
        window.SwymCallbacks.push(swymCallbackFn);

            

        const checkboxes = document.querySelectorAll('.option-block input[type="checkbox"]');
            checkboxes.forEach((checkbox) => {
              checkbox.addEventListener('change', function () {
                const label = checkbox.closest('label');
                if (checkbox.checked) {
                  label.classList.add('selected');
                } else {
                  label.classList.remove('selected');
                }
    

        let quantityInput = checkbox.closest(".product__info-wrapper").querySelector("#total_fractional_yard");
        let rewardMultiplier = quantityInput && quantityInput.value ? parseFloat(quantityInput.value) : 1;

              document.querySelectorAll(".block_product-reward-point").forEach(pointEl => {
                let rawPoints = pointEl.getAttribute("data-point");
                if (rawPoints) {
                  let numericPoints = parseFloat(rawPoints);
                  if (!isNaN(numericPoints)) {
                    let finalPoints = ((numericPoints * rewardMultiplier));
                    pointEl.textContent = Shopify.formatMoney(finalPoints);
                  }
                }
              });

            });

          });
            

          })
          .finally(() => {
            initQuantityBreaks();
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');

            if(document.querySelectorAll(".rebuy-button.loading").length > 0){
              document.querySelectorAll('.rebuy-button.loading').forEach((button) => { 
                button.classList.remove('loading');
                const spinner = button.querySelector('.loading__spinner');
                if (spinner) {
                  spinner.classList.add('hidden');
                }
              });

            }

      
          });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 768px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
function rebuyButton(buttonElement) {
  const dataId = buttonElement.getAttribute('data-id');
  buttonElement.classList.add("loading");
  const spinner = buttonElement.querySelector(".loading__spinner");
  if (spinner) {
    spinner.classList.remove("hidden"); 
  }
  const targetEl = document.querySelector(dataId); 
  if (targetEl) {
    targetEl.click();  
  }
}

